import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

function Contact() {
  const supportEmail = "Mirna.Eid@solidinvestment.com";
  const websiteURL = "https://www.solidinvestment.com";
  const mapsLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3611.2940130735224!2d55.300623775929054!3d25.159548433223517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69c36f082541%3A0x16f65b407bb87f9!2sMeydan%20Grandstand!5e0!3m2!1sen!2slb!4v1737732935723!5m2!1sen!2slb";

  return (
    <div id="contact">
      <div className="contact-container">
        <div className="left">
          <h1>Contact Us</h1>
          <p className="contact-subtitle">
            Want to get in touch? Here's how you can reach us.
          </p>
          <div className="contact-options">
            <div className="contact-option">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="contact-option-icon"
              />
              <a href={`mailto:${supportEmail}`} className="contact-email">
                support@solidinvestment.com
              </a>
            </div>
            <div className="contact-option">
              <FontAwesomeIcon icon={faGlobe} className="contact-option-icon" />
              <a
                href={websiteURL}
                className="contact-website"
              >
                {websiteURL}
              </a>
            </div>
            <div className="contact-option">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="contact-option-icon"
              />
              <span className="contact-location">
                6th Floor, Meydan Grandstand, Dubai, UAE
              </span>
            </div>
          </div>
        </div>
        <div className="right">
          <iframe
            title="Solid Investment Location"
            src={mapsLink}
            width="100%"
            height="100%"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Contact;
